export default __webpack_public_path__ + "static/media/Group8.36c65607.svg";